import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Video } from "lucide-react";
import api from "@/lib/api";

export default function MediaPicker({ open, onClose, clientId, onSelect }) {
  const [media, setMedia] = useState([]);

  useEffect(() => {
    if (!open) return;
    api.get(`/media?visual=1${clientId ? `&client_id=${clientId}` : ""}`)
      .then((r) => setMedia(r.data)).catch(() => {});
  }, [open, clientId]);

  const isVideo = (m) => /\.(mp4|mov|webm)$/i.test(m.name || "");

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="media-picker" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="font-heading">Choisir un visuel dans la médiathèque</DialogTitle></DialogHeader>
        {media.length === 0 ? (
          <p className="text-sm text-neutral-400 text-center py-10" data-testid="media-picker-empty">
            Aucun visuel dans la médiathèque{clientId ? " de ce client" : ""}.
          </p>
        ) : (
          <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
            {media.map((m) => (
              <button key={m.id} data-testid={`media-picker-item-${m.id}`}
                onClick={() => { onSelect(m); onClose(); }}
                className="relative rounded-lg overflow-hidden border border-neutral-200 aspect-square hover:ring-2 hover:ring-neutral-900 transition-shadow bg-neutral-100">
                {isVideo(m) ? (
                  <span className="w-full h-full flex flex-col items-center justify-center text-neutral-400 p-1">
                    <Video className="w-6 h-6" />
                    <span className="text-[9px] mt-1 truncate max-w-full">{m.name}</span>
                  </span>
                ) : (
                  <img src={`${process.env.REACT_APP_BACKEND_URL}${m.url}`} alt={m.name} className="w-full h-full object-cover" loading="lazy" />
                )}
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
